export enum AllowedEntityNames {
    Fires = "fires",
    Flights = "flights",
    Chapters = "chapters",
    InfraredImages = "infrared-images-v1",
    RGBImages = "orthomosaic-images-v1",
    VideoFiles = "video-v1",
    InfraredJobs = "infrared-jobs-v1",
    RGBJobs = "orthomosaic-jobs-v1",
    VideoJobs = "video-jobs-v1",
    PDFJobs = "pdf-jobs-v1",
    Invitations = "invitations",
    Hotspots = "hotspots",
    FirePerimeters = "firePerimeters",
    DetectionProcessingJobs = "detectionProcessingJobs",
    Icons = "icons",
    Tags = "tags",
    Portfolios = "portfolios",
    Members = "members",
    // hybrid entity - not actually stored in dynamoDb, but generated on the fly for now from infrared image center point data
    FlightPaths = "flightPaths",
    Licenses = "licenses",
}
